export const LAYOUT_CATEGORY_SUB = 'layout_category_sub'

export const restEventCommonParams = {
  add_common_params: 'y',
  add_credential: 'y',
  add_timestamp: 'n',
}

export const API_TYPE_CATALOG = 'catalog'
export const API_TYPE_BAND = 'band'
export const EXECUTE_TYPE_TOAST = 'toast'
